import { getFirstName, getLastName } from 'lib/utils/string/normalise';
import {
  BaseTableUserAPIResponse,
  ListUserReturnResult,
  TableRow
} from '../user-table-types';

/**
 * Process data results to TableRow results
 * @param data
 * @returns
 */
export function listUserResponseToTableRow<T extends BaseTableUserAPIResponse>(
  data: ListUserReturnResult<T>,
  options: { invitePending: boolean }
): TableRow<
  T & { firstName: string; lastName: string; invitePending: boolean }
>[] {
  const combined = [...data.data.map(_ => ({ ..._, ...options }))];
  return combined.map(_ => ({
    id: _.id as string,
    key: _.id as string,
    displayName: _.displayName,
    firstName: getFirstName(_.displayName),
    lastName: getLastName(_.displayName),
    email: _.email,
    invitePending: _.invitePending,
    raw: _
  })) as TableRow<
    T & { firstName: string; lastName: string; invitePending: boolean }
  >[];
}
